import { render, staticRenderFns } from "./UploadCertificateCompany.vue?vue&type=template&id=da7559e2&scoped=true&"
import script from "./UploadCertificateCompany.vue?vue&type=script&lang=js&"
export * from "./UploadCertificateCompany.vue?vue&type=script&lang=js&"
import style0 from "./UploadCertificateCompany.vue?vue&type=style&index=0&id=da7559e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7559e2",
  null
  
)

export default component.exports